import React from 'react';
import {API_URL} from '../index';
import Dialog from '@material-ui/core/Dialog';
import { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {Grid, Paper, Divider} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip';


export default function DeleteDialog(props) {

  const [fetching, setFetching] = useState(false);
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [response, setResponse] = useState();

  const handleClose = value => {
    setOpen(false);
  };

  const handleOpen = () => {
  	setOpen(true);
  };

  const Delete = () => {
    setFetching(true)
    const docs_url = API_URL + 'doc_edit/' + props.document.id + '/'
      fetch(docs_url, {
        method: 'DELETE',
        headers: { 'Authorization': 'Token ' + (token), 'Content-Type': 'application/json' }
      })
      .then(e => handleClose())
      .then(e => props.close())
  };

  return(
	<React.Fragment>
        <Tooltip title='Удалить'>
            <IconButton onClick={handleOpen}>
                <DeleteForeverIcon color="error"/>
            </IconButton>
        </Tooltip>
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth maxWidth='xs'>
      <DialogTitle id="simple-dialog-title">Удаление
      <Tooltip title='Закрыть' placement='left-end' style={{float: 'right'}}>
        <IconButton onClick={handleClose}>
          <CloseIcon/>
        </IconButton>
      </Tooltip>
      </DialogTitle>
        <DialogContent>
          <DialogContentText>
          {'Вы действительно хотите удалить ' + (props.document.title != null ? props.document.title : 'документы') + '?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button style={{color: 'red'}} onClick={Delete}>
            Удалить
          </Button>
          <Button color="primary" onClick={handleClose}>
            Отмена
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    )
}